import { FC } from 'react';

import { Icon } from '@/shared/ui';

import styles from './counterSimple.module.scss';

interface CounterSimpleProps {
  count?: number;
  increment?: () => void;
  decrement?: () => void;
  incrementDisabled?: boolean;
}

const CounterSimple: FC<CounterSimpleProps> = (props) => {
  const { count = 1, increment, decrement, incrementDisabled = false } = props;
  return (
    <div className={styles.counter}>
      <button
        aria-label="Уменьшить количество"
        className={styles.counter__btn}
        disabled={count < 1}
        onClick={decrement}
      >
        <Icon name="minusBig" />
      </button>
      <p className={styles.counter__text}>{count}</p>
      <button
        aria-label="Увеличить количество"
        className={styles.counter__btn}
        disabled={incrementDisabled}
        onClick={increment}
      >
        <Icon name="plusBig" />
      </button>
    </div>
  );
};

export default CounterSimple;
